let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsDisjointedResult определяет структуру результата логической проверки на непересечение одного объекта другим
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsDisjointedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsDisjointedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsDisjointedResult";
  }
}

module.exports = IsDisjointedResult;